import { render, staticRenderFns } from "./userBanned.vue?vue&type=template&id=4feafb55&"
import script from "./userBanned.vue?vue&type=script&lang=js&"
export * from "./userBanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4feafb55')) {
      api.createRecord('4feafb55', component.options)
    } else {
      api.reload('4feafb55', component.options)
    }
    module.hot.accept("./userBanned.vue?vue&type=template&id=4feafb55&", function () {
      api.rerender('4feafb55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/userBanned.vue"
export default component.exports